import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TIndustryForm } from "@/features/learning-content/types/industryForm";
import { CardContainer } from "@/components/commons/CardContainer";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { Grid, Stack, Typography } from "@mui/material";

type TExamInfoFormProps = {};

export const ExamInfoForm: FC<TExamInfoFormProps> = () => {
  const { control } = useFormContext<TIndustryForm>();

  return (
    <CardContainer sx={{ borderRadius: "8px" }}>
      <Stack gap={3}>
        <Typography variant="sub16Bold" sx={{ fontSize: "20px", fontWeight: 700 }}>
          試験基本情報
        </Typography>

        <FormField control={control} name="examOrganization" label="試験実施機関">
          <Input fullWidth placeholder="入力してください" />
        </FormField>

        <Grid container spacing={3}>
          <Grid item xs={6}>
            <FormField control={control} name="examInfoReleaseEstimate" label="試験情報の公開目安">
              <Input fullWidth placeholder="入力してください" />
            </FormField>
          </Grid>

          <Grid item xs={6}>
            <FormField control={control} name="examInfoUrl" label="試験情報URL">
              <Input fullWidth placeholder="入力してください" />
            </FormField>
          </Grid>
        </Grid>
      </Stack>
    </CardContainer>
  );
};
